import api from "../../services/api";
import type {
  Registration,
  RegistrationStatus,
  DecideRegistrationRequest,
  GetRegistrationSettingsResponse,
  SaveRegistrationSettingsRequest,
  SaveRegistrationSettingsResponse,
} from "./types";

export const registrationApi = {
  /**
   * A tournament's registration configuration, or null when setup has not run.
   */
  getSettings: async (tournamentId: string): Promise<GetRegistrationSettingsResponse> => {
    return api.get(`/tournaments/${tournamentId}/registration-settings`);
  },

  /**
   * Save the wizard's configuration. Upserts, so running setup again replaces
   * what is there rather than failing.
   */
  saveSettings: async (
    tournamentId: string,
    data: SaveRegistrationSettingsRequest
  ): Promise<SaveRegistrationSettingsResponse> => {
    return api.put(`/tournaments/${tournamentId}/registration-settings`, data);
  },

  /**
   * Every entry for this tournament, oldest first. Organiser only.
   * Omit `status` for all of them.
   */
  listRegistrations: async (
    tournamentId: string,
    status?: RegistrationStatus
  ): Promise<Registration[]> => {
    const query = status ? `?status=${status}` : "";
    const response = await api.get(`/tournaments/${tournamentId}/registrations${query}`);
    /* Defensive: a shape change should empty a tab, not crash it. */
    return Array.isArray(response) ? (response as Registration[]) : [];
  },

  /** Accept or decline a pending entry. */
  decideRegistration: async (
    tournamentId: string,
    registrationId: string,
    data: DecideRegistrationRequest
  ): Promise<Registration> => {
    return api.patch(`/tournaments/${tournamentId}/registrations/${registrationId}`, data);
  },
};
